// Fonte: UManutContas.pas — Ds_Saldos → consulta em Saldos + Ativo
// Disponível para: Tipos 1, 2, 4, 8
// Permissão para forçar lançamento: ForcaLancamento (36)
import React, { useState, useEffect, useCallback } from 'react';
import { Table, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { listarSaldosConta } from '~/Services/Service';
import { formatarMonetario } from '~/Utils/Helpers';

var TabSaldos = function(_ref) {
  var ge = _ref.ge;
  var codigo = _ref.codigo;

  var [lista, setLista] = useState([]);
  var [loading, setLoading] = useState(false);

  var carregar = useCallback(function() {
    if (!ge || !codigo) return;
    setLoading(true);
    listarSaldosConta(ge, codigo)
      .then(function(resp) {
        setLista(Array.isArray(resp) ? resp : []);
      })
      .catch(function() { toast.error('Erro ao carregar saldos'); })
      .finally(function() { setLoading(false); });
  }, [ge, codigo]);

  useEffect(function() { carregar(); }, [carregar]);

  var totalSaldo = lista.reduce(function(acc, item) {
    var s = parseFloat(item.saldo_atual);
    return acc + (isNaN(s) ? 0 : s);
  }, 0);

  return (
    <div className="contas-tab-content">
      {loading ? (
        <div className="text-center py-3"><Spinner animation="border" /></div>
      ) : (
        <Table size="sm" bordered className="contas-sub-grid">
          <thead>
            <tr>
              <th>Cod. Ativo</th>
              <th>Nome</th>
              <th>Saldo</th>
            </tr>
          </thead>
          <tbody>
            {lista.length === 0 ? (
              <tr><td colSpan={3} className="text-center text-muted">Nenhum saldo</td></tr>
            ) : (
              lista.map(function(item, i) {
                return (
                  <tr key={item.codigo_ativo !== null && item.codigo_ativo !== undefined ? item.codigo_ativo : 'saldo_' + i}>
                    <td>{item.codigo_ativo !== null && item.codigo_ativo !== undefined ? item.codigo_ativo : '-'}</td>
                    <td>{item.apelido_ativo !== null && item.apelido_ativo !== undefined ? item.apelido_ativo : '-'}</td>
                    <td className="text-right">{item.saldo_atual !== null && item.saldo_atual !== undefined ? formatarMonetario(item.saldo_atual, false) : '-'}</td>
                  </tr>
                );
              })
            )}
          </tbody>
          {lista.length > 0 && (
            <tfoot>
              <tr className="font-weight-bold">
                <td colSpan={2} className="text-right">Total:</td>
                <td className="text-right">{formatarMonetario(totalSaldo, false)}</td>
              </tr>
            </tfoot>
          )}
        </Table>
      )}
    </div>
  );
};

export default TabSaldos;
